"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEntityDefinitionNamed = void 0;
var use_entities_1 = require("./use-entities");
var useEntityDefinitionNamed = function (entityTypeName) {
  var entities = (0, use_entities_1.useEntities)();
  var entityDefinition = entities[entityTypeName];
  // if (!entityDefinition) {
  //   throw new Error(`Entity definition is missing for ${entityTypeName}`);
  // }
  return entityDefinition;
};
exports.useEntityDefinitionNamed = useEntityDefinitionNamed;